import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Vue from 'vue'

/* eslint-disable */
Vue.component('vv-observer', ValidationObserver)
Vue.component('vv-provider', ValidationProvider)
